/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I calculate my age on a future or past date?`)
};

const es_age_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo calcular mi edad en una fecha futura o pasada?`)
};

const de_age_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich mein Alter an einem zukünftigen oder vergangenen Datum berechnen?`)
};

const nl_age_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik mijn leeftijd op een toekomstige of vroegere datum berekenen?`)
};

const fr_age_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je calculer mon âge à une date future ou passée ?`)
};

const it_age_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso calcolare la mia età in una data futura o passata?`)
};

const pt_br2_age_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso calcular minha idade em uma data futura ou passada?`)
};

const pt_age_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso calcular a minha idade numa data futura ou passada?`)
};

const ja_age_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将来または過去の日付で年齢を計算できますか？`)
};

const zh_age_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以计算未来或过去某个日期的年龄吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_faq2_q", locale)
	if (locale === "en") return en_age_faq2_q(inputs)
	if (locale === "es") return es_age_faq2_q(inputs)
	if (locale === "de") return de_age_faq2_q(inputs)
	if (locale === "nl") return nl_age_faq2_q(inputs)
	if (locale === "fr") return fr_age_faq2_q(inputs)
	if (locale === "it") return it_age_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_age_faq2_q(inputs)
	if (locale === "pt") return pt_age_faq2_q(inputs)
	if (locale === "ja") return ja_age_faq2_q(inputs)
	return zh_age_faq2_q(inputs)
};